import { CommonActionTypes } from "../../action-types";

const paymentTypes = JSON.parse(localStorage.getItem("paymentTypes"));
const initialState = {
  paymentTypes: paymentTypes ? paymentTypes : null,
};

export default function paymentTypesReducer(state = initialState, action) {
  switch (action.type) {
    case CommonActionTypes.GET_PAYMENT_TYPE:
      return {
        paymentTypes: action.payload,
      };
    default:
      return state;
  }
}
